export const Logo = ({ variant = "dark" }) => {
  const isDark = variant === "dark";
  return (
    <a
      href="#top"
      data-testid="site-logo"
      className="flex items-center gap-3 group"
    >
      <img
        src="/ts-logo.png"
        alt="Top Service logo"
        className="h-11 w-auto object-contain transition-transform duration-300 group-hover:-translate-y-0.5"
      />
      <span className="flex flex-col leading-none">
        <span
          className={`font-heading text-lg font-bold tracking-tight ${
            isDark ? "text-[#0F172A]" : "text-white"
          }`}
        >
          Top Service
        </span>
        <span
          className={`font-mono text-[10px] tracking-[0.18em] uppercase ${
            isDark ? "text-amber-600" : "text-amber-400"
          }`}
        >
          Supplies &amp; Imports
        </span>
      </span>
    </a>
  );
};
